"use client";

import { Suspense } from "react";
import { LanguageProvider } from "./components/lang-context";

export default function MarketingLayout({
    children,
}: {
    children: React.ReactNode;
}) {
    return (
        <Suspense fallback={null}>
            <LanguageProvider>
                {children}
            </LanguageProvider>
        </Suspense>
    );
}
